<template>
  <div>
    <template v-for="(field, index) in fields">
      <component
        :is="field.component || 'VTextField'"
        :key="index"
        dense
        outlined
        :error="isErrorField(field)"
        v-model="data[field.code]"
        :label="getLabel(field)"
      />
    </template>
    <slot name="button" v-bind="{validate,errorFields}" />
  </div>
</template>

<script>
import AddressCountryInputWithoutFetch from '@/components/Address/AddressCountryInputWithoutFetch';
import { VTextField } from 'vuetify/lib';

import {
  onMounted, ref, toRefs, watch,
} from '@vue/composition-api';
import { useI18n } from 'vue-i18n-composable';

export default {
  name: 'PaymentMethodCardAddress',
  components: { AddressCountryInputWithoutFetch, VTextField },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  setup(props, { emit }) {
    const { value } = toRefs(props);
    const data = ref({ ...value.value });
    const { t } = useI18n();

    const validator = (val) => !!val;

    const fields = ref([{
      code: 'country', req: true, validator, component: 'AddressCountryInputWithoutFetch',
    }, { code: 'line1', req: true, validator }, { code: 'line2' }, { code: 'region' }, { code: 'city', req: true, validator }, { code: 'postcode', req: true, validator }]);

    function getLabel(field) {
      return `${t(field.code)}${field.req ? ' *' : ''}`;
    }

    const errorFields = ref([]);

    function validate() {
      const valid = (f) => {
        return typeof f.validator !== 'function' || f.validator(data.value[f.code]);
      };
      errorFields.value = fields.value.filter((f) => f.req && !valid(f));

      if (errorFields.value?.length > 0) {
        return false;
      }
      return true;
    }

    function isErrorField(field) {
      return errorFields.value.some((f) => f.code === field.code);
    }

    onMounted(() => {
      emit('initValidate', validate);
    });

    watch(data, () => {
      emit('input', data.value);
    }, {
      deep: true,
    });

    return {
      data,
      fields,
      getLabel,
      isErrorField,
      validate,
      errorFields,
    };
  },
};
</script>

<style scoped>

</style>

<i18n lang="yml" locale="ru">
  country: Страна
  line1: Адрес (строка 1)
  line2: Адрес (строка 2)
  region: Регион
  city: Населенный пункт
  postcode: Почтовый индекс
</i18n>
<i18n lang="yml" locale="en">
  country: Country
  line1: Address (line 1)
  line2: Address (line 2)
  region: Region (State)
  city: City
  postcode: ZIP (Postal code)
</i18n>
